import './ContextMenuCustomContent.4c726fc7dba335bba544faad9747f123.css';
export default {"content":"_content_1okqv_1"};